module.exports = __webpack_public_path__ + "media/images/pic/godzilla/pattern-9e53821332c9a315959f1bcc6cf50554.svg";